import { Vehicle } from '@otw/models/inventory'
import { VehiclePhotosRenderer } from '@/components/inventory/renderers/VehiclePhotosRenderer'

interface InventoryV3PhotosDetailProps {
  vehicle: Vehicle
  canModify: boolean
  onUploadStateChange?: (vehicleId: string, isUploading: boolean) => void
}

/**
 * Detail panel wrapper for the MUI grid. `VehiclePhotosRenderer` was written for
 * AG Grid's master/detail, where `node.expanded` gates the photo query. MUI only
 * mounts the detail panel when it is open, so `expanded` is always true here.
 */
export const InventoryV3PhotosDetail = ({ vehicle, canModify, onUploadStateChange }: InventoryV3PhotosDetailProps) => (
  <VehiclePhotosRenderer
    data={vehicle}
    node={{ expanded: true }}
    canModify={canModify}
    onUploadStateChange={onUploadStateChange}
  />
)
